import { render, staticRenderFns } from "./image_selector.vue?vue&type=template&id=18bdfb10&"
import script from "./image_selector.vue?vue&type=script&lang=coffee&"
export * from "./image_selector.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports